import React from "react";

function NotFound() {
  return (
    <div className="h-full w-full text-lg">
      <div className="text-gray-700 text-center my-24 mx-auto space-y-4">
        <h1 className="text-6xl font-bold">
          4<span className="text-gray-500">0</span>4
        </h1>
        <h2 className="text-3xl">Page non trouvée</h2>
        <p>La page que vous recherchez n'existe pas.</p>
      </div>
    </div>
  );
}

export default NotFound;
